/**
 * The vertical rhythm, as four steps.
 *
 * There is no arbitrary gap number in the kit. Eighteen families each picking
 * their own 6, 7, 8, 9 and 11 is how a system stops reading as one system, and
 * the four steps here are the whole vocabulary.
 */
"use client";
import type { ReactElement, ReactNode } from "react";
import { CRC_STACK_GAP } from "./cresultcard.tokens";
import { CresultcardStackDensity } from "./cresultcard.types";

interface CresultcardStackProps {
  readonly children: ReactNode;
  readonly density?: CresultcardStackDensity;
}

export function CresultcardStack({
  children,
  density = CresultcardStackDensity.Regular,
}: CresultcardStackProps): ReactElement {
  return (
    <div
      data-el="Cresultcard/Stack/Root"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: CRC_STACK_GAP[density],
        minWidth: 0,
      }}
    >
      {children}
    </div>
  );
}
